import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import StatusLabel from 'components/Luxkit/Label/StatusLabel'
import React, { MouseEventHandler, useCallback } from 'react'

interface Props {
  /**
   * The percentage the budget is exceeded by.
   */
  exceedingPercentage: number
  onClick: MouseEventHandler<HTMLButtonElement>
}

function PriceRowBusinessTravellerExceededBudget(props: Props) {
  const {
    exceedingPercentage,
    onClick,
  } = props

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()

    onClick(event)
  }, [onClick])

  return <Clickable onClick={handleClick}>
    <StatusLabel variant="pending" endIcon={<LineInfoCircleIcon />}>
      Exceeds budget by {exceedingPercentage}%
    </StatusLabel>
  </Clickable>
}

export default PriceRowBusinessTravellerExceededBudget
